import { render } from "./consulta-padrao.vue?vue&type=template&id=446dd276"
import script from "./consulta-padrao.vue?vue&type=script&lang=js"
export * from "./consulta-padrao.vue?vue&type=script&lang=js"

import "./consulta-padrao.vue?vue&type=style&index=0&id=446dd276&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__